import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface RenderedSection{
  sectionId?:string;
  sectionIndex?:number;
  rendererType?:string;
  elementId?:string
}

@Injectable({
  providedIn: 'root'
})
export class SectionEditorBridgeService {
  public sectionElements:BehaviorSubject<RenderedSection[]> = new BehaviorSubject<RenderedSection[]>([]);
  public elementId$ = new Subject<string>();
  public delElementId$ = new Subject<string>();
  public showElement$ = new Subject<string>();
  public hideElement$ = new Subject<string>();
  public editElementId$ = new Subject<string>();
  public thumnails$:BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public cellIdsThumbs$:BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public cellLayoutThumbs$:BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  constructor() { }

  setSectionElements(sections:RenderedSection[]){
    //console.log(sections)
    this.sectionElements.next(sections)
  }

  getSectionElements():Observable<RenderedSection[]>{
    return this.sectionElements.asObservable()
  }

  setSelectedSection(elementId:string){
    console.log(`Track Element Id: ${elementId}`);
    this.elementId$.next(elementId);
  }

  getSelectedSection():Observable<string>{
    return this.elementId$.asObservable()
  }

  setDelSelectionElement(elementId:string){
    this.delElementId$.next(elementId);
  }

  getDelSectionElement():Observable<string>{
    return this.delElementId$.asObservable();
  }

  toggleElementVisibility(elementId:string,shown:boolean){
    if(shown){
      this.showElement$.next(elementId)
    }else{
      this.hideElement$.next(elementId)
    }
  }

  getHidden():Observable<string>{
    return this.hideElement$.asObservable()
  }

  getShown():Observable<string>{
    return this.showElement$.asObservable()
  }

  setEditElement(elementId:string){
    this.editElementId$.next(elementId)
  }

  getEditElement():Observable<string>{
    return this.editElementId$.asObservable();
  }

  setSectionThumbnails(thumbnails:any[]){
    console.log("Track Setting ThumbNails:"+thumbnails)
    this.thumnails$.next(thumbnails);
  }
  getSectionThumbnails():Observable<any[]>{
    this.thumnails$.subscribe(data => {console.log(`Track Getting ThumbNails: ${data}`)})
    return this.thumnails$.asObservable();
  }
  setCellIdsThumbs(cellIdsThumbs:any[]){
    this.cellIdsThumbs$.next(cellIdsThumbs);
  }

  getCellIdsThumbs():Observable<any[]>{
    return this.cellIdsThumbs$.asObservable();
  }

  setCellLayoutOptions(layoutThumbs:any[]){
    console.log(layoutThumbs)
    this.cellLayoutThumbs$.next(layoutThumbs)
  }

  getCellLayoutOptions():Observable<any[]>{
    return this.cellLayoutThumbs$.asObservable()
  }
}
